module.exports = __webpack_public_path__ + "static/media/youtube.0bff535f.svg";